import { useMemo } from 'react'
import { formatCurrency } from '../utils/formatUtils'

export default function useFormatCurrencyMemo(val:number){
	return useMemo(() => formatCurrency(val), [val])
}
